export default function CRMStats({ customers }) {
  const totalBonus = customers.reduce((sum, c) => sum + parseFloat(c.bonus_balance), 0);
  const blacklisted = customers.filter(c => c.is_blacklisted).length;
  const verified = customers.filter(c => c.age_verified).length;

  const stats = [
    { num: customers.length, label:'Клієнтів', color:'#fff' },
    { num: totalBonus.toFixed(0), label:'Бонусів в обігу', color:'#f5a623' },
    { num: verified, label:'Вік підтверджено', color:'#5fbf8f' },
    { num: blacklisted, label:'Чорний список', color:'#ff6b6b' },
  ];

  return (
    <div style={styles.statsBar}>
      {stats.map((s, i) => (
        <div key={i} style={styles.statItem}>
          <span style={{...styles.statNum, color:s.color}}>{s.num}</span>
          <span style={styles.statLabel}>{s.label}</span>
        </div>
      ))}
    </div>
  );
}

const styles = {
  statsBar: { background:'#211c14', borderBottom:'1px solid #38301f', padding:'10px 32px', display:'flex', alignItems:'center' },
  statItem: { display:'flex', flexDirection:'column', alignItems:'center', padding:'0 24px', borderRight:'1px solid #38301f' },
  statNum: { fontSize:'20px', fontWeight:'bold' },
  statLabel: { fontSize:'11px', color:'#9a8a6e', marginTop:'2px' },
};
